import React from 'react';
import { clamp } from 'ramda';

import { useOfferContext } from '../../../context';
import { CSS_LINE_HEIGHT, Description } from '../../../components/Description';

interface IDescriptionContainerProps {
  setCallback(fn: () => void): void;
}

export function DescriptionContainer({ setCallback }: IDescriptionContainerProps) {
  const {
    isTop,
    offer: { description },
  } = useOfferContext();

  const containerRef = React.useRef<HTMLDivElement>(null);

  const [linesCount, setLinesCount] = React.useState<number | undefined>();

  const calcHeight = React.useCallback(() => {
    if (containerRef.current) {
      setLinesCount(clamp(0, 5, Math.floor(containerRef.current.clientHeight / CSS_LINE_HEIGHT)));
    }
  }, []);

  // пересчитываем максимальное количество строк описания
  React.useEffect(() => {
    setCallback(calcHeight);
    calcHeight();
  }, [calcHeight, setCallback]);

  if (!description) {
    return null;
  }

  return <Description promoted={isTop} ref={containerRef} lines={linesCount} text={description} />;
}
